module.exports = __webpack_public_path__ + "static/media/github.acf718bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact/github.png
// module id = 1506
// module chunks = 0